var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.162 6.885v1.449l-2.642.755c-.55.158-1 .755-1 1.328v.52h5.722",
    transform: "translate(-288 -292) translate(275 279) translate(13.878 13) translate(.5 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.283 6.852v1.481l2.64.756c.55.158 1.001.755 1.001 1.328v.52H5.202",
    transform: "translate(-288 -292) translate(275 279) translate(13.878 13) translate(.5 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.844 3.929c0 1.882-1.399 3.407-3.122 3.407-1.724 0-3.121-1.525-3.121-3.407C2.601 2.046 3.998.52 5.722.52c1.723 0 3.122 1.525 3.122 3.408z",
    transform: "translate(-288 -292) translate(275 279) translate(13.878 13) translate(.5 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.811 3.331c-.52.521-2.008.496-2.569-.55-1.04 1.042-2.73 1.042-3.572.447M17.687 6.885v1.449l-2.642.755c-.549.158-1 .755-1 1.328v.52h5.723",
    transform: "translate(-288 -292) translate(275 279) translate(13.878 13) translate(.5 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.808 6.868v1.465l2.64.756c.551.158 1.002.754 1.002 1.327v.521h-5.723",
    transform: "translate(-288 -292) translate(275 279) translate(13.878 13) translate(.5 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.369 3.929c0 1.882-1.398 3.407-3.121 3.407-1.724 0-3.122-1.525-3.122-3.407 0-1.883 1.398-3.408 3.122-3.408 1.723 0 3.12 1.525 3.12 3.408z",
    transform: "translate(-288 -292) translate(275 279) translate(13.878 13) translate(.5 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.32 3.328c-.52.521-1.991.5-2.552-.546-1.04 1.041-2.731 1.041-3.573.446M10.924 20.426v1.45l-2.641.755c-.55.158-1 .755-1 1.328v.52h5.722",
    transform: "translate(-288 -292) translate(275 279) translate(13.878 13) translate(.5 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.046 20.426v1.45l2.64.755c.55.158 1.001.755 1.001 1.328v.52h-5.722",
    transform: "translate(-288 -292) translate(275 279) translate(13.878 13) translate(.5 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.606 17.47c0 1.883-1.398 3.408-3.121 3.408-1.724 0-3.121-1.525-3.121-3.408 0-1.882 1.397-3.407 3.121-3.407 1.723 0 3.121 1.525 3.121 3.407z",
    transform: "translate(-288 -292) translate(275 279) translate(13.878 13) translate(.5 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.557 16.844c-.52.52-1.99.525-2.552-.521-1.04 1.041-2.73 1.041-3.572.448",
    transform: "translate(-288 -292) translate(275 279) translate(13.878 13) translate(.5 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M4.162 13.021L6.763 15.625M20.808 13.021L18.207 15.625",
    transform: "translate(-288 -292) translate(275 279) translate(13.878 13) translate(.5 .5)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrga);
export default __webpack_public_path__ + "static/media/orga.758c6244.svg";
export { ForwardRef as ReactComponent };